module.exports = __webpack_public_path__ + "img/live_layout.02d4ac8b.svg";